module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stats":"Stats","configs":"Configs","show configs":"show configs","show stats":"show stats","search":"Search","rack":"Rack","include all phases":"Include all phases"},"de":{"stats":"Statistiken","configs":"Konfigurationen","show configs":"zeige Konfigurationen","show stats":"zeige Statistiken","search":"Suche","rack":"Rack","include all phases":"Alle Phasen anzeigen"}}')
  delete Component.options._Ctor
}
